import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import googleIcon from '../../../assets/icons/google.svg';
import facebookIcon from '../../../assets/icons/facebook-signup.svg';
import xIcon from '../../../assets/icons/x.svg';
import linkedinIcon from '../../../assets/icons/linkedin.svg';
import './SignupForm.css';

const EyeIcon = ({ show }) => (
  show ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  )
);

export const SignupForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(formData);
  };

  return (
    <div className="signup-form-wrapper">
      <h2 className="signup-title">Sign Up</h2>
      <p className="signup-subtitle">Enter details to create your account</p>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="signupUsername">
          <Form.Label className="signup-label">Username</Form.Label>
          <Form.Control
            type="text"
            name="username"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            className="signup-input"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="signupEmail">
          <Form.Label className="signup-label">Email ID</Form.Label>
          <Form.Control
            type="email"
            name="email"
            placeholder="Email ID"
            value={formData.email}
            onChange={handleChange}
            className="signup-input"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="signupPassword">
          <Form.Label className="signup-label">Password</Form.Label>
          <div className="signup-input-eye">
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="signup-input"
              required
            />
            <button
              type="button"
              className="signup-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Toggle password visibility"
            >
              <EyeIcon show={showPassword} />
            </button>
          </div>
        </Form.Group>

        <Form.Group className="mb-4" controlId="signupConfirmPassword">
          <Form.Label className="signup-label">Confirm Password</Form.Label>
          <div className="signup-input-eye">
            <Form.Control
              type={showConfirm ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="signup-input"
              required
            />
            <button
              type="button"
              className="signup-eye-btn"
              onClick={() => setShowConfirm(!showConfirm)}
              aria-label="Toggle confirm password visibility"
            >
              <EyeIcon show={showConfirm} />
            </button>
          </div>
        </Form.Group>

        <Button type="submit" className="signup-register-btn w-100">
          Register
        </Button>
      </Form>

      <p className="signup-login-text">
        Already Registered?{' '}
        <Link to="/login" className="signup-login-link">Log in</Link>
      </p>

      <div className="signup-divider">
        <span>OR</span>
      </div>

      <div className="signup-social-row">
        <button className="signup-social-btn" aria-label="Sign up with Google">
          <img src={googleIcon} alt="Google" width="18" height="18" />
        </button>
        <button className="signup-social-btn" aria-label="Sign up with Facebook">
          <img src={facebookIcon} alt="Facebook" width="18" height="18" />
        </button>
        <button className="signup-social-btn" aria-label="Sign up with X">
          <img src={xIcon} alt="X" width="18" height="18" />
        </button>
        <button className="signup-social-btn" aria-label="Sign up with LinkedIn">
          <img src={linkedinIcon} alt="LinkedIn" width="18" height="18" />
        </button>
      </div>
    </div>
  );
};
